import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/laboratorio-cliente-exame`

    return {
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        store(laboratorioId, params) {
            return repository.post(`${baseUrl}/${laboratorioId}`, params)
        },
        edit(id) {
            return repository.get(`${baseUrl}/${id}/edit`)
        },
        update(laboratorioId, id, params) {
            return repository.put(`${baseUrl}/${laboratorioId}/${id}`, params)
        },
        destroy(laboratorioId, id) {
            return repository.delete(`${baseUrl}/${laboratorioId}/${id}`)
        },
        datatable(queryParms = {}) {
            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
    }
}